import React from 'react';
import red from '@material-ui/core/colors/red';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { ValidatorComponent } from 'react-material-ui-form-validator';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const red300 = red['500'];

const style = {
    fontSize: '12px',
    color: red300,
};

class RadioValidatorElement extends ValidatorComponent {
    constructor(props) {
        super(props);

        this.State = {
            value: props.value
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({ value: this.props.value });
        }
    }

    render() {
        const { errorMessages, validators, requiredError, value, ...rest } = this.props;
        
        return (
            <React.Fragment>
                <Grid item xs={12}>
                    <Typography>{this.props.question}</Typography>
                </Grid>
                <Grid item xs={12} style={{ marginLeft: '10px' }}>
                    
                    <RadioGroup
                        name={this.props.name}
                        value={this.props.value === undefined ? undefined : this.props.value.toString()}
                        onChange={this.props.readOnly !== null && this.props.readOnly !== undefined ? "" : this.handleChange}
                        readOnly={rest.readOnly}
                        name={rest.name}
                        children={rest.children}
                        ref={(r) => { this.input = r; }}                        
                    >
                        <FormControlLabel value="true" control={<Radio />} label={this.props.trueLabel} />
                        <FormControlLabel value="false" control={<Radio />} label={this.props.falseLabel} />
                    </RadioGroup>
                </Grid>
                {this.errorText()}
            </React.Fragment>
        );
    }

    //validate = () => {
    //    super.validate(this.state.value)
    //}

    //validate = (currValue) => {
    //    super.validate(currValue)
    //}

    handleChange = (event) => {
        this.setState({ value: (event.target.value === "true" ? true : false) }, () => {
            this.validate(this.state.value);
        });
        this.props.handleChange(event);
        
    }

    errorText = () => {

        const { isValid } = this.state;

        if (isValid) {
            return null;
        }

        return (
            <Grid item xs={12} justify="flex-end" alignItems="flex-end">
                <Typography align="right" style={style}>
                    {this.getErrorMessage()}
                </Typography>
            </Grid>
        );
    }
}

export default RadioValidatorElement;